import { render } from "./CloseIcon.vue?vue&type=template&id=ff979e1e"
import script from "./CloseIcon.vue?vue&type=script&lang=js"
export * from "./CloseIcon.vue?vue&type=script&lang=js"

import exportComponent from "/home/runcloud/webapps/doctorsconnection/releases/20230927172851/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__